export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/product_descriptions.153a9c1.svg";